import React from "react";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";

const PrivacyPolicy = () => {
  return (
    <>
      <Navbar />

      {/* Page Header */}
      <div style={styles.header}>
        <div style={styles.container}>
          <h1 style={styles.title}>Privacy Policy Page</h1>
          <div style={styles.breadcrumb}>
            Home / <span style={styles.active}>“Privacy Policy”</span>
          </div>
        </div>
      </div>

      {/* Content */}
      <div style={styles.contentWrapper}>
        <div style={styles.container}>

          <p><strong>Effective Date: January, 28, 2026</strong></p>

          <p>
            At Z1 Technology and Trade, we value your privacy and are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, and safeguard your data when you interact with our website, mobile app, and services. By using Z1 Technology, you agree to the terms described in this policy.
          </p>

          <Section
            title="1. Information We Collect "
            text="We collect personal information that you voluntarily provide when using our platform, including but not limited to:"
            list={[
              "a. Name, email address, phone number, and physical address",
              "b. Payment information (for purchases and refunds)",
              "c. Transaction history and preferences",
              "d. Location data (for delivery and service purposes)",
            ]}
          />

          <Section
            title="2. How We Use Your Information "
            text="The information we collect is used solely to provide and improve our services. We use your data for: "
            list={[
              "a. Processing orders and managing transactions ",
              "b. Facilitating deliveries and customer support",
              "c. Enhancing your experience by personalizing the platform",
              "d. Sending updates on orders, services, and promotions (with your consent)",
              "e. We do not share or sell your personal information to third parties for marketing or other purposes. Your data is only shared with trusted service providers when necessary to complete a transaction, such as payment gateways and delivery services.",
            ]}
          />

          <Section
            title="3. Data Security"
            text="We are dedicated to protecting your data and ensuring its confidentiality. We employ industry-standard security measures such as encryption and firewalls to protect your information from unauthorized access, disclosure, alteration, or destruction."  
          />

          <Section
            title="4. User Privacy ,Your personal data is treated with the utmost care. We ensure: "
          />
           <p>a. Your data is only used for the purposes you consent to.</p>
          <p>b. We comply with all relevant privacy laws and regulations in Nepal and internationally.</p>
          <p>c. Only authorized personnel have access to your information, and they are bound by confidentiality</p>
          <p>d. You have the right to request access to your personal data, correct inaccuracies, or delete your account. e. Simply contact us at <b>z1techbhw@gmail.com</b> to make any requests related to your data.</p>

          <Section
            title="5. Cookies and Tracking Technologies "
            text="We use cookies and similar tracking technologies to improve your experience on our platform. These technologies help us understand your preferences, track your order status, and provide a smoother, more personalized service. You can control the use of cookies through your browser settings."
          />

          <Section
            title="6. Data Retention"
            text="We retain your information for as long as necessary to fulfill the purposes outlined in this Privacy Policy or as required by law. If you wish to delete your account or any personal data, please contact us, and we will act promptly to comply with your request."
          />

          <Section
            title="7. Changes to This Privacy Policy"
            text="We may update this Privacy Policy from time to time to reflect changes in our practices or for legal, technical, or regulatory reasons. When we make changes, we will notify you by updating the Effective Date at the top of this page and providing notice through other means as necessary."
          />

          <Section title="8. Contact Us">
            <p>
              If you have any questions or concerns regarding these Privacy Policy, please contact us at:
            </p>

            <p style={{ marginTop: "16px" }}>
              <strong>Z1 Technology & Trade Pvt. Ltd.</strong><br />
              Siddharthanagar-12, Bhairahawa, Lumbini, Nepal<br />
              Email: z1techbhw@gmail.com<br />
              Phone: 071590132, 9857050123
            </p>
          </Section>
        </div>
      </div>

      <Footer />
    </>
  );
};

const Section = ({ title, text, list, children }) => (
  <div style={styles.section}>
    <h3 style={styles.sectionTitle}>{title}</h3>
    {text && <p>{text}</p>}
    {list && (
      <ul>
        {list.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    )}
    {children}
  </div>
);

const styles = {
  header: {
    padding: "40px 0",
    background: "#ffffff",
    borderBottom: "1px solid #e5e7eb",
  },
  container: {
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "0 16px",
  },
  title: {
    fontSize: "28px",
    fontWeight: "700",
    marginBottom: "6px",
  },
  breadcrumb: {
    fontSize: "14px",
    color: "#6b7280",
  },
  active: {
    color: "#2563eb",
  },
  contentWrapper: {
    padding: "40px 0",
    background: "#ffffff",
  },
  section: {
    marginTop: "28px",
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: "700",
    marginBottom: "8px",
  },
};

export default PrivacyPolicy;
